import {
    DomainInitPayload,
    Subscription,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getSubscriptionAdditionalData } from '@sxm-de/dev-kits/web-sdk/domains/subscriptions-core';
import { getSubscription } from '../helpers/get-subscription';

interface GetSubscriptionDetailsFnPayload {
    subscriptionId: string;
}

export type GetSubscriptionDetailsFn = (
    payload: GetSubscriptionDetailsFnPayload,
) => Promise<{
    subscription: Subscription;
}>;

export function initGetSubscriptionDetailsFn({
    dependencies,
}: DomainInitPayload): GetSubscriptionDetailsFn {
    return async ({ subscriptionId }: GetSubscriptionDetailsFnPayload) => {
        try {
            const subscription = await getSubscription(
                { subscriptionId },
                dependencies,
            );

            const { detailedState } = await getSubscriptionAdditionalData(
                {
                    subscription,
                },
                dependencies,
            );

            return {
                subscription: {
                    ...subscription,
                    detailedState,
                },
            };
        } catch (error: any) {
            // TODO: handle error scenarios like 404 vs a System error
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
